module.exports = __webpack_public_path__ + "static/media/hero-real-estate.b29b863e.png";